<template>
  <div class="page">
    <div>
      <!-- 右上角三横杠按钮 -->
    <el-button 
      class="menu-button"
      icon="el-icon-menu"
      @click="showDrawer = true"
      circle
    ></el-button>

    <!-- 右侧抽屉 -->
    <el-drawer
      title="菜单"
      :visible.sync="showDrawer"
      direction="rtl"
      size="30%"
    >
      <div style="display: flex; flex-direction: column; gap: 15px; padding: 10px;">
        <el-button type="primary" icon="el-icon-setting" style="margin-left: 0;" @click="setClick('gross')">调整粗动作方案</el-button>
        <el-button type="success" icon="el-icon-setting" style="margin-left: 0;" @click="setClick('fine')">调整细动作方案</el-button>
        <el-button type="warning" icon="el-icon-setting" style="margin-left: 0;" @click="setClick('level')">调整训练级别</el-button>
        <el-button type="warning" icon="el-icon-refresh" style="margin-left: 0;" @click="refreshReport">重新生成报告</el-button>
        <el-button type="info" icon="el-icon-back" @click="goBack" style="margin-left: 0;">返回</el-button>
      </div>
      <!-- <el-menu>
        <el-menu-item index="1" @click="handleClick('home')">
          <i class="el-icon-house"></i> 首页
        </el-menu-item>
        <el-menu-item index="2" @click="handleClick('profile')">
          <i class="el-icon-user"></i> 个人中心
        </el-menu-item>
        <el-menu-item index="3" @click="handleClick('settings')">
          <i class="el-icon-setting"></i> 设置
        </el-menu-item>
        <el-menu-item index="4" @click="handleClick('logout')">
          <i class="el-icon-switch-button"></i> 退出登录
        </el-menu-item>
      </el-menu> -->
    </el-drawer>
    </div>
    <!-- <div v-html="html"></div> -->
     <div v-if="errorMessage" class="error-container">
       <el-alert
         :title="errorMessage"
         type="warning"
         :closable="false"
         show-icon>
       </el-alert>
       <el-button type="primary" @click="goBack" style="margin-top: 20px;">返回上一页</el-button>
     </div>
     <div v-else><iframe 
      frameborder="0" 
      width="100%" 
      :src="htmlUrl"
      ref="reportIframe"
      scrolling="no"
      @load="listenForIframeHeight"
    ></iframe></div>
  </div>
</template>

<script>
import useAppStore from '../stores/modules/app'
import { viewReport, getEvaluaNumberBySid } from '@/api/app'
import { Loading } from 'element-ui'
export default {
  name: 'PreviewreportHtml',
  /* components: {
      PageBuilder
  }, */
  data () {
    return {
      html: '',
      showDrawer: false, // 控制抽屉的显示
      appStore: null,
      htmlUrl: '',
      errorMessage: '', // 错误提示信息
      dev_prefix: 'http://192.168.80.40:8188'
    }
  },
  created (){
    this.appStore = useAppStore()
     //this.html = this.appStore.getItem('PreviewReportHtml')
    this.htmlUrl = '' //this.appStore.getItem('htmlUrl')
    
   
    if(this.$route.query.evalua_number && 'undefined' != this.$route.query.evalua_number){
      console.log('预览报告111：', this.$route.query.evalua_number);
      this.htmlUrl = '/' + 'report/' + this.$route.query.evalua_number + '.html?t=' + new Date().getTime()
      if('development' === process.env.NODE_ENV){
        this.htmlUrl = this.dev_prefix + this.htmlUrl
      }
      
    } else if(this.$route.query.sid) {
      // 当evalua_number为undefined时，通过sid查询最新的evalua_number
      this.fetchEvaluaNumberBySid(this.$route.query.sid)
    }
    console.log('NODE_ENV:', process.env.NODE_ENV)
    //this.appStore = useAppStore()
    console.log('预览报告222：', 888);
  },
  mounted () {
      //this.fetchData()
      //this.html = '<div><h1>888欢迎使用</h1><p>点击文本开始编辑</p></div>'
    //   this.appStore = useAppStore()
    // this.html = this.appStore.cache.previewReportHtml
    // console.log('预览报告2：', this.appStore.cache);
    //console.log('query====', this.$route.query);
  },
  methods: {
    async fetchEvaluaNumberBySid(sid) {
      try {
        const result = await getEvaluaNumberBySid({ sid: sid })
        console.error('获取evalua_number失败:', result)
        if (result.evalua_number) {
          this.htmlUrl += '/report/' + result.evalua_number + '.html?t=' + new Date().getTime()
          if('development' === process.env.NODE_ENV){
            this.htmlUrl = this.dev_prefix + this.htmlUrl
          }
          console.log('通过sid获取evalua_number成功:', this.htmlUrl)
        } else {
          this.errorMessage = '未找到对应的测评记录'
        }
      } catch (error) {
        this.errorMessage = '获取测评记录失败，请稍后重试'
        console.error('获取evalua_number失败:', error)
      }
    },
    listenForIframeHeight() {
      window.addEventListener('message', (event) => {
        // 验证消息来源（可选但推荐）
        // if (event.origin !== 'https://your-iframe-domain.com') return;
        
        if (event.data.type === 'iframeHeight') {
          this.$refs.reportIframe.style.height = event.data.height + 'px';
        }
      });
    },
    goBack() {
      this.$router.go(-1) // 后退一步
    },
    setClick (type) {
      this.showDrawer = false; // 关闭抽屉
      this.$router.push({ path: '/setplan', query: { eid: this.$route.query.eid, type:type, age: this.$route.query.age} }) // 导航到指定路由
    }, 
    async refreshReport (event) {
      console.log('预览报告按钮被点击:', event);
      // 显示加载层
      this.loadingInstance = Loading.service({ fullscreen: true })
      //this.loading = true;
      try {
        const result = await viewReport({
            student_id: this.$route.query.sid,
            evalua_id: this.$route.query.eid,
            preview: true,
        });
        //this.appStore.setItem('PreviewReportHtml',result.html)
        this.appStore.setItem('htmlUrl',result.pdfPath)
        this.html = result.html
        this.htmlUrl = result.pdfPath
        this.loadingInstance && this.loadingInstance.close()
        this.showDrawer = false; // 关闭抽屉
        this.$message.success('重新生成报告成功')
      } catch (error) {
        // console.error('Failed to view report:', error);
        this.$message.error('重新生成报告失败，请稍后重试');
        this.loadingInstance && this.loadingInstance.close()
      } finally {
        // this.loading = false;
        this.loadingInstance && this.loadingInstance.close()
      }      
    },   
    handleContentChange(newContent) {
      console.log('内容已更改:', newContent)
    },
    handleSave(content) {
      console.log('保存内容:', content)
      // 这里可以调用API保存内容
    },
    handleClick(menuItem) {
      console.log(`点击了 ${menuItem}`);
      this.$message.info(`你选择了 ${menuItem}`);
      this.showDrawer = false; // 关闭抽屉
    }
  }
}
</script>

<style>
iframe {
  display: block; /* 移除默认的内联元素间隙 */
  border: none; /* 移除默认边框 */
  min-height: 100px; /* 设置最小高度避免折叠 */
}
.page {
  padding: 20px;
  max-width: 900px;
  margin: 0 auto;
  padding-bottom: 100px;
}
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
}
/* 右上角菜单按钮样式 */
.menu-button {
  position: fixed;
  top: 15px;
  right: 15px;
  z-index: 1000;
  background-color: #409eff;
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/views/PreviewreportHtml.vue